export default "__VITE_ASSET__BjAOYWoA__"